import { render, staticRenderFns } from "./firewall_detail.vue?vue&type=template&id=8b45cc18"
import script from "./firewall_detail.vue?vue&type=script&lang=js"
export * from "./firewall_detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports